<template>
    <fieldset>
        <slot />
    </fieldset>
</template>

<script setup>
const modelValue = defineModel({
    type: [String, null],
    required: false
})

const props = defineProps({
    name: {
        type: String,
        required: true
    }
})

provide('radioName', props.name)
provide('radioModel', modelValue)
</script>
